<template>
  <div class="header">
    <span class="thread-title" :style="{ color: threadColor }">
      {{ thread.subject }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    thread: {
      type: Object,
      default: () => ({})
    },
    threadColor: {
      type: String,
      default: 'inherit'
    }
  }
}
</script>

<style scoped lang="sass">
  .header
    font-size: 14px
    display: flex
    align-items: center
    justify-content: center
    width: 100%
    @media only screen and (max-width: 600px)
      font-size: 12px

</style>
